<script>
import { mapActions } from "vuex";
import Loading from "@/components/layout/Loading.vue";
import TextTruncator  from "@/components/structures/TextTruncator.vue";
import Likes from "@/components/likes.vue";
import { toDate, toTime } from "@/utils/time.js";

export default {
  props: {
    data: {},
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      likesSelected: [],
    };
  },
  components: {
    Loading,
    Likes,
    TextTruncator,
  },
  methods: {
    ...mapActions("home", ["addLikeLastVideo", "delLikeLastVideo"]),

    async toggleLikeVideo(video) {
      const liked = !!video.confirm_like;
      const data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: video.id_video,
      };
      let res = null;
      if (!liked) {
        res = await this.addLikeLastVideo(data_);
      } else {
        res = await this.delLikeLastVideo(data_);
      }

      if (!res) {
        this.toastGenericError();
      }
    },
    textLike(gal) {
      const { likes, confirm_like } = gal;
      if (likes.length == 0) return "";
      if (likes.length == 1 && confirm_like != null) return "Te gusta";
      return "Le gusta a";
    },
    toDate(date) {
      return toDate(date);
    },
    toTime(date) {
      return toTime(date);
    },
  },
};
</script>

<template>
  <section class="widget">
    <Loading v-if="loading" pixeles="100px" class="mb-3" />
    <div
      v-if="!loading"
      class="card card-custom border-0 mb-3"
    >
      <div
        class="d-flex justify-content-between align-items-center p-3 pb-0 color-main"
      >
        <p class="d-flex align-items-center font-title font-700 mb-0">
          <img width="40" src="@/assets/img/intranet/home/icono-tw-tv.png" />
          <span>Último video</span>
        </p>
        <router-link
          class="font-title font-700 color-main"
          :to="`/videos/${data.id_video}`"
        >
          Ver más
        </router-link>
      </div>
      <div class="card-body h-auto">
        <!--<figure class="card-custom-thumb">
            <router-link 
              class="card-custom-thumb-link"
              :to="`/videos/${data.id_video}`"
            >
              <img 
                :src="data.url_imagen"
                class="card-custom-thumb-img border"
              >
            </router-link>
          </figure>-->
        <figure class="card-custom-thumb h-auto mb-1">
          <video
            class="card-custom-thumb-img border"
            controlslist="nofullscreen nodownload noremoteplayback noplaybackrate foobar"
            controls
            :src="data?.url_video"
          ></video>
        </figure>
        <div class="d-flex align-items-right">
          <small class="m-0 ms-auto text-secondary text-right">
            {{ toDate(data.fecha_video) }} {{ toTime(data.fecha_video) }}
          </small>
        </div>
        <div class="card-custom-post">
          <TextTruncator 
            class="font-700 text-secondary mb-0"
            :max="100"
            tag="h5"
          >
          {{ data.titulo_video }}
        </TextTruncator>
        </div>
      </div>
      <div
        class="card-custom-footer d-flex p-3 pt-0 justify-content-end align-items-center"
      >
        <div>
          <a
            href="javascript:"
            @click="
              textLike(data) !== 'Te gusta' && (likesSelected = data.likes)
            "
            class="me-2"
          >
            {{ textLike(data) }}
          </a>
          <a
            href="javascript:"
            @click="toggleLikeVideo(data)"
            class="card-custom-footer-like color-main"
          >
            <span v-if="!data?.confirm_like" key="solid-heart">
              <font-awesome-icon icon="fa-solid fa-heart"></font-awesome-icon>
            </span>
            <span v-else key="regular-heart">
              <font-awesome-icon
                icon="fa-solid fa-heart"
                class="color-red"
              ></font-awesome-icon>
            </span>
          </a>
          <span class="card-custom-footer-like-count ms-1">
            {{ data.likes.length }}
          </span>
        </div>
        <div class="ms-3">
          <router-link
            :to="`/videos/${data?.id_video}`"
            class="card-custom-footer-like color-main"
          >
            <font-awesome-icon icon="fa-solid fa-comment"></font-awesome-icon>
          </router-link>
          <span class="card-custom-footer-like-count ms-1">
            {{ data.comentarios != null ? data.comentarios.length : "" }}
          </span>
        </div>
      </div>
    </div>
    <Likes
      v-show="likesSelected.length > 0"
      :likes="likesSelected"
      @close="likesSelected = []"
    ></Likes>
  </section>
</template>
